import { Box, Typography } from '@mui/material';
import { HourglassEmpty } from '@mui/icons-material';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

function AprovacaoPendente() {
  const { t } = useTranslation();

  return (
    <Box sx={{ textAlign: 'center' }}>
      <Helmet title={t('Pending approval')} />
      <Box
        sx={{
          width: 72,
          height: 72,
          borderRadius: '50%',
          bgcolor: 'rgba(237, 108, 2, 0.1)',
          color: 'warning.main',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mx: 'auto',
          mb: 2,
        }}
      >
        <HourglassEmpty sx={{ fontSize: 36 }} />
      </Box>
      <Typography variant="h5" gutterBottom>
        {t('Pending approval')}
      </Typography>
      <Typography variant="body2">
        {t('Your judge invitation is under review. You will be notified as soon as your participation is confirmed.')}
      </Typography>
    </Box>
  );
}

export default AprovacaoPendente;
